import { ListItemIcon, ListItemIconProps } from '@mui/material'
import React, { FC } from 'react';

const ListItemIconWrapper: FC<ListItemIconProps> = ({...props}) => <ListItemIcon {...props}/>

export default ListItemIconWrapper;